import { gql, useQuery } from "@apollo/client";
import Session from "@lib/session";
import { Configuration, QueryConfigArgs } from "@graphql/api";
import FrameConfig from "@lib/classes/FrameConfig";

const query = (fields: (keyof Configuration)[]) => gql`
query config($mode: ConfigMode, $serviceAreaId: Int) {
  ${configSchema(fields)}
}
`;

const variables = (): QueryConfigArgs => ({
  mode: new FrameConfig().mode as QueryConfigArgs["mode"],
  serviceAreaId: Session.getBooking().serviceArea,
});

export const configSchema = (fields: (keyof Configuration)[]) => `
  config(mode: $mode, serviceAreaId: $serviceAreaId) {
    id
    ${fields.join("\n")}
  }
`;

interface ConfigQuery<T extends keyof Configuration> {
  __typename?: "Query";
  config: Pick<Configuration, "id"> & Pick<Configuration, T>;
}

export async function getConfig<T extends (keyof Configuration)[]>(
  fields: T = [] as unknown as T,
) {
  type Fields = T[number];

  return await global.window.apolloClient.query<ConfigQuery<Fields>, QueryConfigArgs>({
    query: query(fields),
    variables: variables(),
  });
}

function useConfig<T extends (keyof Configuration)[]>(fields: T = [] as unknown as T) {
  type Fields = T[number];
  return useQuery<ConfigQuery<Fields>, QueryConfigArgs>(query(fields), { variables: variables() });
}

export default useConfig;
